import { useNavigate } from 'react-router-dom';

const steps = [
  {
    icon: 'ri-search-line',
    title: '翻找第一现场',
    desc: '回到最初那条爆料，查证它的原始出处、配图与发布语境。',
  },
  {
    icon: 'ri-list-check-3',
    title: '梳理完整脉络',
    desc: '把散落在旧报道、旧访谈与老照片里的线索，按时间线重新串联。',
  },
  {
    icon: 'ri-focus-3-line',
    title: '逐帧考古细节',
    desc: '放大当年被一笔带过的细节，找出被忽视的伏笔与后来的验证。',
  },
  {
    icon: 'ri-file-shield-line',
    title: '标注事实边界',
    desc: '公开事实与网络传言分得清清楚楚，绝不拿推测冒充当年真相。',
  },
];

const badges = [
  { icon: 'ri-shield-check-line', text: '来源优先 · 可追溯' },
  { icon: 'ri-mental-health-line', text: '观点中立 · 不引流' },
  { icon: 'ri-archive-line', text: '档案沉淀 · 持续更新' },
  { icon: 'ri-user-heart-line', text: '尊重当事人 · 不伤害' },
];

export default function TrustBand() {
  const navigate = useNavigate();
  return (
    <section className="relative overflow-hidden bg-background-200">
      <div className="container-x py-14 md:py-20">
        <div className="mx-auto max-w-3xl text-center">
          <p className="text-sm font-medium tracking-widest text-primary-700">OUR APPROACH</p>
          <h2 className="mt-2 font-display text-2xl font-black text-foreground-900 md:text-4xl">
            我们这样「考古重读」一条旧瓜
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-600 md:text-base">
            重读不是为了博眼球的「翻车」，而是把当年没讲完的故事，放进今天更完整的信息里重新讲清楚。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <div
              key={s.title}
              className="relative rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <span className="absolute right-5 top-4 font-display text-4xl font-black text-accent-300/50">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-xl text-primary-700">
                <i className={s.icon}></i>
              </span>
              <h3 className="mt-4 font-display text-lg font-bold text-foreground-900">{s.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          {badges.map((b) => (
            <span
              key={b.text}
              className="inline-flex items-center gap-2 rounded-full border border-accent-300/70 bg-accent-100/60 px-4 py-2 text-sm text-accent-900"
            >
              <i className={b.icon}></i>{b.text}
            </span>
          ))}
        </div>

        <div className="mt-10 text-center">
          <button
            onClick={() => navigate('/about')}
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            认识故纸瓜档
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>
    </section>
  );
}